<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" (click)="expandOrCollapse()" [ngClass]="{'pointer': !isEdit}">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        <h3>Collector Protocols</h3>

        <div class="float-end header-button-container" (click)="$event.stopPropagation()">
            @if (!isEdit && showBody && canEdit) {
                <button class="ace-btn btn-text has-icon btn-primary"
                        (click)="editMode()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (isEdit && showBody) {
                <div>
                    <button class="ace-btn btn-text has-icon btn-primary btn-success" (click)="savePanel()" [disabled]="!protocolForm.valid || saving">
                        <i class="fa fa-save"></i>
                    </button>
                    <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancelEdit()" [disabled]="saving">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
            }
        </div>

    </div>
    @if (showBody) {
        <div class="panel-flat-body">
            @if (collector && protocolForm) {
                <div class="collector" [formGroup]="protocolForm">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" formControlName="originalTaxBillRequired">
                            Collector requires original tax bill
                        </label>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" formControlName="receiveByDueDate">
                            Payment must be received by due date
                        </label>
                    </div>
                    <div class="form-inline">
                        @if (isEdit) {
                            <label class="ws-font-weight-normal">
                                Maximum <input type="text"
                                               class="form-control input-number max-items-field"
                                               name="fieldMaxItemsPerCheck"
                                               formControlName="maxItemsPerCheck"
                                               [numbersOnly]="true"
                                               [decimalAllowed]="false"
                                               [negativeAllowed]="false"> payment
                                item{{ maxItemsPerCheck.value > 1 || maxItemsPerCheck.value === 0 ? 's' : '' }} per
                                check
                            </label>
                        }
                        @if (maxItemsPerCheck.invalid && (maxItemsPerCheck.dirty || maxItemsPerCheck.touched)) {
                            <div class="text-danger">
                                @if (maxItemsPerCheck.errors?.min) {
                                    <div>
                                        *Value cannot be lower than 0
                                    </div>
                                }
                                @if (maxItemsPerCheck.errors?.max) {
                                    <div>
                                        *Value cannot be greater than 1000
                                    </div>
                                }
                            </div>
                        }
                        @if (!isEdit) {
                            <span>Maximum {{ collector.maxItemsPerCheck || 0 }}
                                payment item{{ (collector.maxItemsPerCheck > 1 || collector.maxItemsPerCheck === 0 ? 's' : '') }}
                                per check</span>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>
